import { render, staticRenderFns } from "./PracticeDetail.vue?vue&type=template&id=65ed10a1&scoped=true"
import script from "./PracticeDetail.vue?vue&type=script&lang=js"
export * from "./PracticeDetail.vue?vue&type=script&lang=js"
import style0 from "./PracticeDetail.vue?vue&type=style&index=0&id=65ed10a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed10a1",
  null
  
)

export default component.exports